import axios from 'axios'

const api = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}/api`,
})

export default {
  getEvents() {
    return api.get('/meetings')
  },
  createEvent(data) {
    return api.post('/meetings', data)
  },
  updateEvent(id, data) {
    return api.put(`/meetings/${id}`, data)
  },
  deleteEvent(id) {
    return api.delete(`/meetings/${id}`)
  }
}
